var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 32,
    viewBox: "0 0 1 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    width: 1,
    height: 32,
    rx: 0.5,
    fill: "#B4B5B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalLine);
export default __webpack_public_path__ + "static/media/verticalLine.b1a8efb1be9a2cd9b886037d081e53f4.svg";
export { ForwardRef as ReactComponent };